// extracted by mini-css-extract-plugin
module.exports = {"Content":"Layout_Content__3H3X8","Ribbon":"Layout_Ribbon__3FlO8","RibbonText":"Layout_RibbonText__1jqwC"};